import { FC, ReactNode } from "react";
import { Badge, Card } from "@justworkshr/milo-core";
import styles from "./BackgroundCheck.module.css";

interface StatusData {
  badgeRole: "positive" | "negative" | "warning";
  badgeText: "Passed" | "Unsuccessful" | "Pending";
  header: string;
  body: string | ReactNode;
}

interface Props {
  status: string;
}

const BackgroundCheckStatus: FC<Props> = ({ status }) => {
  let statusData: StatusData;

  if (status === "criteria_met") {
    statusData = {
      badgeRole: "positive",
      badgeText: "Passed",
      header: "Congratulations!",
      body: "Your background check has been processed and is complete.",
    };
  } else {
    statusData = {
      badgeRole: "warning",
      badgeText: "Pending",
      header: "We're reviewing your background check",
      body: "When this is complete, you will receive an update.",
    };
  }

  return (
    <Card className={`${styles.card} ${styles.statusCard}`} title="">
      {statusData && (
        <>
          <Badge role={statusData.badgeRole}>{statusData.badgeText}</Badge>

          <h2 className={styles.cardTitle}>{statusData.header}</h2>

          <p className={styles.paddingTop}>{statusData.body}</p>
        </>
      )}
    </Card>
  );
};

export default BackgroundCheckStatus;
